import React from "react";
import axios from "axios";
import { Table, Button, Input, Icon, Divider, Popconfirm, message } from 'antd';
import { withRouter } from "react-router-dom";
import ContactForm from "./ContactForm";
import { withTranslation } from 'react-i18next';


const { Search } = Input;


class ContactList extends React.Component {
    state = {
        selectedRowKeys: [],
        modalContact: {},
        modalRequestType: '',
        // modalLoading: true,
        modalBtnText: "",
        modalVisible: false,
        modalTitleText: "",
        contacts: [],
    };


    componentDidMount() {
        let token = localStorage.getItem('token');
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
        axios.defaults.headers = {
            "Content-Type": "application/json",
            "Accept-Language": localStorage.getItem('language'),
            Authorization: `Token ${token}`,
        };
        this.fetch();
    }

    fetch = e => {
        let requestList = [];
        requestList.push(axios.get(process.env.REACT_APP_AXIOS_URL + "/api/contacts/"));

        axios.all(requestList).then(axios.spread((...responses) => {
            const responseContacts = responses[0];

            this.setState({
                contacts: responseContacts.data.results,
            });
        })).catch(errors => {
            console.log(errors);
        });
    }

    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.props.pagination };
        pager.current = pagination.current;

        let sorter_field = sorter.field;
        if (sorter_field && sorter_field.includes("display"))
            sorter_field = sorter_field.substring(0, sorter_field.length - 8);

        this.props.handleState('pagination', pager);
        this.props.handleState('sortedInfo', {
            order: sorter.order,
            columnKey: sorter_field
        });
        this.props.fetch({
            results: pagination.pageSize,
            page: pagination.current,
            sortField: sorter_field,
            sortOrder: sorter.order
        });
    };

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    handleDeleteSelected = (event) => {
        this.props.handleState('loading', true);
        this.state.selectedRowKeys.filter((key, index) => {
            axios.delete(process.env.REACT_APP_AXIOS_URL + `/api/contacts/${key}/delete/`)
                .then(res => {
                    if (res.status === 204 || res.status === 200) {
                        return true;
                    }
                })
        });

        let data = this.props.data;
        data = data.filter(item => {
            return !this.state.selectedRowKeys.includes(item.id);
        });
        setTimeout(() => {
            this.props.handleState('data', data);
            this.props.handleState('loading', false);
            this.setState({
                selectedRowKeys: [],
            });
        }, 1000);
    };

    handleState = (key, value) => {
        let obj = {};
        obj[key] = value;
        this.setState(obj);
    }

    handleSearch = (value) => {
        this.props.handleState('searchText', value);
        this.props.fetch({
            search: value,
            sortField: this.props.sortedInfo['columnKey'],
            sortOrder: this.props.sortedInfo['order']
        });
    };


    handleDelete(contactID, recordID) {
        axios.delete(process.env.REACT_APP_AXIOS_URL + `/api/contacts/${contactID}/delete/`)
            .then(res => {
                if (res.status === 204 || res.status === 200) {
                    const data = [...this.props.data];
                    delete data[recordID];
                    const data_fixed = data.filter(item => item.key !== recordID)
                    this.props.handleState('data', data_fixed);
                    message.success(this.props.t('contacts.contact_list.contact_deleted', "Contact deleted"));
                } else {
                    message.warning(this.props.t('contacts.contact_list.contact_deletion_failed', "Deletion failed"));
                }
            })
    };

    confirmDelete(event, contactID, recordID) {
        event.preventDefault();
        this.handleDelete(contactID, recordID);
    }

    showModal = () => {
        this.formRef.resetFields();
        this.setState({
            modalVisible: true,
            modalTitleText: this.props.t('contacts.contact_list.modal_title_create', "Create a new contact"),
            modalRequestType: "post",
            modalBtnText: this.props.t('general.create', "Create"),
            modalContact: {},
        });
    };

    hideModal = () => {
        this.setState({
            modalVisible: false,
        });
    };

    handleCreate = () => {
        this.formRef.validateFields((err, values) => {
            if (err) {
                return;
            }

            const postObj = {
                ...values
            }

            this.hideModal();
            axios.post(process.env.REACT_APP_AXIOS_URL + "/api/contacts/create/", postObj)
                .then(res => {
                    if (res.status === 201) {
                        this.props.fetch();
                        message.success(this.props.t('contacts.contact_list.contact_created', "Contact created successfully"));
                    }
                })

            this.formRef.resetFields();
        });
    };

    handlePreview = event => {
        const contactID = event.currentTarget.getAttribute('data-record_id');
        this.formRef.resetFields();
        axios.get(process.env.REACT_APP_AXIOS_URL + `/api/contacts/${contactID}/`)
            .then(res => {
                if (res.status === 200) {
                    this.setState({
                        modalContact: res.data,
                        // modalLoading: false,
                        modalBtnText: undefined,
                        modalVisible: true,
                        modalRequestType: "get",
                        modalTitleText: this.props.t('contacts.contact_list.modal_title_preview', "Previewing a contact")
                    });
                } else {
                    this.props.history.push('/contacts');
                }
            })
    };

    handleEditPreview = event => {
        const contactID = event.currentTarget.getAttribute('data-record_id');
        this.formRef.resetFields();
        axios.get(process.env.REACT_APP_AXIOS_URL + `/api/contacts/${contactID}/`)
            .then(res => {
                if (res.status === 200) {
                    this.setState({
                        modalContact: res.data,
                        // modalLoading: false,
                        modalBtnText: this.props.t('general.update', "Update"),
                        modalVisible: true,
                        modalRequestType: "put",
                        modalTitleText: this.props.t('contacts.contact_list.modal_title_update', "Update contact")
                    });
                } else {
                    this.props.history.push('/contacts');
                }
            })
    };

    handleEdit = event => {
        this.formRef.validateFields((err, values) => {
            if (err) {
                return;
            }

            const postObj = {
                ...values
            }
            const contactID = this.state.modalContact.id;
            this.hideModal();
            axios.put(process.env.REACT_APP_AXIOS_URL + `/api/contacts/${contactID}/update/`, postObj)
                .then(res => {
                    if (res.status === 200) {
                        this.props.fetch();
                        message.success(this.props.t('contacts.contact_list.contact_updated', "Contact have been updated"));
                    }
                })

            // this.formRef.resetFields();
        });
    };

    saveFormRef = formRef => {
        this.formRef = formRef;
    };

    render() {
        const { selectedRowKeys } = this.state;
        const { t } = this.props;

        const columns = [
            {
                title: t('contacts.contact_list.first_name', "First name"),
                dataIndex: 'first_name',
                key: 'first_name',
                sorter: true,
                ellipsis: true,
            },
            {
                title: t('contacts.contact_list.last_name', "Last name"),
                dataIndex: 'last_name',
                key: 'last_name',
                sorter: true,
                ellipsis: true,
            },
            {
                title: t('contacts.contact_list.email', "Email"),
                dataIndex: 'email',
                key: 'email',
                sorter: true,
                ellipsis: true,
            },
            {
                title: t('contacts.contact_list.phone', "Phone"),
                dataIndex: 'phone',
                key: 'phone',
                sorter: true,
                ellipsis: true,
            },
            {
                title: t('general.actions', "Actions"),
                ellipsis: true,
                fixed: 'right',
                render: (text, record, index) => (
                    <span>
                        {/* <Link to={{
                            pathname: '/contacts/' + record.id,
                            state: { requestType: "put" }
                        }} */}
                        {/* >Edit</Link> */}
                        <Button size='small' onClick={this.handlePreview} data-record_id={record.id} title={t('general.view', "View")} icon='eye' />
                        {/* <Divider type="vertical" /> */}
                        <Button style={{ marginLeft: '5px' }} type='primary' size='small' onClick={this.handleEditPreview} data-record_id={record.id} title={t('general.edit', "Edit")} icon='edit' />
                        {/* <Divider type="vertical" /> */}
                        <Popconfirm
                            title={t('contacts.contact_list.contact_delete', "Are you sure want to delete this contact?")}
                            onConfirm={(event) => {
                                this.confirmDelete(event, record.id, index);
                            }}
                            okText={t('general.yes', "Yes")}
                            cancelText={t('general.no', "No")}
                            className='data-id={record.id}'
                        >
                            <Button style={{ marginLeft: '5px' }} type='danger' size='small' href="#" title={t('general.delete', "Delete")} icon='delete' />
                            {/* <a onClick={this.handleDelete} data-id={record.id} data-record_id={index}>Delete</a> */}
                        </Popconfirm>
                    </span>
                ),
            }
        ];

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            hideDefaultSelections: true,
            selections: [
                {
                    key: 'delete',
                    text: t('general.delete', "Delete"),
                    onSelect: this.handleDeleteSelected
                },
            ],
        };

        return (
            <div>
                <div className="to-do-header">
                    <Search
                        placeholder={t('contacts.contact_list.search', "Find contact")}
                        onSearch={value => this.handleSearch(value)}
                        style={{ width: 200, margin: 8 }}
                    />
                    <div style={{ float: 'right' }}>
                        <Button style={{ margin: 8 }} type="primary" onClick={this.showModal}>
                            <Icon type="plus" />
                            {t('general.create', "Create")}
                        </Button>
                    </div>
                </div>
                <div className="to-do-content">
                    <Table
                        rowSelection={rowSelection}
                        columns={columns}
                        onChange={this.handleTableChange}
                        rowKey={record => record.id}
                        dataSource={this.props.data}
                        pagination={this.props.pagination}
                        loading={this.props.loading}
                    />
                </div >
                <ContactForm
                    wrappedComponentRef={(form) => this.formRef = form}
                    visible={this.state.modalVisible}
                    onCancel={this.hideModal}
                    btnText={this.state.modalBtnText}
                    titleText={this.state.modalTitleText}
                    handleState={this.handleState}
                    requestType={this.state.modalRequestType}
                    data={this.state.modalContact}
                    fetch={this.props.fetch}
                    contacts={this.state.contacts}
                />
            </div>
        );
    }
}


export default withRouter(withTranslation()(ContactList));



// WEBPACK FOOTER //
// ./src/containers/Contacts/ContactList.js